import * as Stores from '../stores'

export function useBenefitStatementCredits({ benefitId }: { benefitId: string }) {
  const benefitStatementCredits = Stores.CardBenefitsApi.endpoints[
    'GET /benefits/:benefitId/statement-credits'
  ].useQuery(
    { params: { benefitId } },
    {
      selectFromResult({ data, isLoading, isUninitialized, isSuccess, error }) {
        return {
          isUninitialized,
          isLoading,
          isSuccess,
          error,
          data: data?.amount !== undefined ? data.amount : null,
        }
      },
    },
  )

  return benefitStatementCredits
}
